import React, { useState, useEffect } from "react";
import RegisterForm from "../../components/Auth/RegisterForm";
import LoadingCircle from "../../components/Common/LoadingCircle";

const RegisterPage = () => {
  const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 0); 
      return () => clearTimeout(timer);
    }, []);
   
  if (isLoading) return <LoadingCircle fullPage={true} size="lg" />;

  return (
     <div className="min-h-screen w-full flex flex-col bg-[#f8fafc] dark:bg-slate-900 relative overflow-hidden font-sans">
      <main className="relative z-10 flex-grow w-full flex flex-col items-center justify-start pt-32 md:pt-40 pb-12">
        <div className="w-full max-w-[1200px] flex justify-center px-6">
          <RegisterForm />
        </div>
      </main>
    </div>
  );
};

export default RegisterPage;